import { mergeDeepLeft } from 'ramda';
import { IS_CLIENT } from '../constants';
import { getLocale } from '../locale';
import { getStoreLocatorBaseURL } from '../url/getStoreLocatorURL';
const OPTION_TYPES = {
    BASE: 'base',
    ADOBE: 'adobe',
    STORE_LOCATOR: 'storelocator',
    STORE_LOCATOR_RADIUS: 'storelocatorradius',
};
export const DEFAULT_OPTIONS = {
    use: {
        locale: true,
        apiVersion: true,
    },
    customLocale: '',
    apiVersion: 1,
    type: OPTION_TYPES.BASE,
};
/**
 * Builds the url from an array, sorting out falsy values
 * @param {array} fragments An array of entries that will be concatenated with /
 * @param {string} [base] An optional base URL
 */
const buildUrl = (fragments = [], base = IS_CLIENT && process.env.TYPE_OF_LINK !== 'server'
    ? window.location.origin
    : process.env.NODE_ENVIRONMENT
        ? `${process.env.SSR_CONTENT_API_ROOT}`
        : 'http://localhost:8080') => [base]
    .concat(fragments)
    .filter((fragment) => !!fragment)
    .join('/');
/**
 * Returns an absolute path to the correct endpoint depending on options and environment
 * @param {string} endpoint The specific endpoint
 * @param {object} userOptions An object of options. See DEFAULT_OPTIONS in getApiUrl.js
 */
const getApiUrl = (endpoint, userOptions = {}) => {
    const isExternalUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
    if (isExternalUrlRegex.test(endpoint)) {
        return endpoint;
    }
    const options = mergeDeepLeft(userOptions, DEFAULT_OPTIONS);
    const locale = options.use.locale ? options.customLocale || getLocale() : '';
    const apiVersion = options.use.apiVersion ? `v${options.apiVersion}` : '';
    const trimmedEndpoint = endpoint.replace(/^\//, '');
    let suffix = '';
    switch (options.type) {
        case OPTION_TYPES.BASE:
            return buildUrl([locale, apiVersion, trimmedEndpoint]);
        case OPTION_TYPES.STORE_LOCATOR_RADIUS:
            return buildUrl([trimmedEndpoint]);
        case OPTION_TYPES.STORE_LOCATOR:
            return buildUrl([apiVersion, 'brand/hm', endpoint, locale, `${options.query || ''}`], getStoreLocatorBaseURL());
        case OPTION_TYPES.ADOBE:
            suffix = `${apiVersion ? '.' : ''}${apiVersion}.json${options.query || ''}`; // falls through
            return buildUrl([locale, `${trimmedEndpoint}${suffix}`]);
        default:
            // If we are not on base (we are using ADOBE endpoints. atm ( member / customer-service ))
            return buildUrl([locale, `${trimmedEndpoint}${suffix}`]);
    }
};
export default getApiUrl;
//# sourceMappingURL=getApiUrl.js.map